<template>
	<div class="container pt-5 my-5">
		<header class="jumbotron">
			<h3>Лесопилка</h3>
		</header>
		<p class="text-center">
			<img src="//iwstatic.g.bsrv.su/resources/images/wood1.jpg" width="150" height="106" /> <img src="//iwstatic.g.bsrv.su/resources/images/wood5.jpg" width="150" height="106" />
		</p>
		<p><b>Лесопилка</b> - строение, в котором добывается ресурс "дерево". Максимальное количество уровней - 10.</p>
		<p><b>Особенности строения:</b></p>
	</div>
</template>

<style lang="css">

</style>

<script>
export default {
	name: 'WikiOpisLesopilka',
	computed: {
		currentUser(){
			return this.$store.state.user;
		},
	},
	/*mounted() {
		if (!this.currentUser) {
			this.$router.push('/login');
		}
	}*/
};
</script>